import { IPDFTableHeader } from "src/Pages/components/PDF/TableHeader";
import { PDFTableHeader } from "src/Pages/components/PDF/TableHeader/PDFTableHeader";

export const HeadPDFResumeConfirmationReceipt = () => {
  const dataHeaderPDF: IPDFTableHeader = [
    {
      title: "Produtor",
      style: { width: "17%", textAlign: "left", paddingLeft: "8px" },
    },
    {
      title: "Valor comissão",
      style: { width: "12%", textAlign: "right" },
    },
    {
      title: "Conta corrente atual",
      style: { width: "14%", textAlign: "right" },
    },
    {
      title: "Valor a pagar",
      style: { width: "12%", textAlign: "right" },
    },
    {
      title: "Conta corrente restante",
      style: {
        width: "15%",
        textAlign: "right",
        paddingRight: "8px",
        borderRight: "1px solid #292929",
      },
    },
    //
    {
      title: "Banco",
      style: { width: "5%", textAlign: "right" },
    },
    {
      title: "Agência",
      style: { width: "6%", textAlign: "right" },
    },
    {
      title: "Conta",
      style: { width: "8%", textAlign: "right" },
    },
    {
      title: "Pix",
      style: { width: "11%", textAlign: "right", paddingRight: "8px" },
    },
  ];

  return <PDFTableHeader data={dataHeaderPDF} />;
};
